import { isCompanyAdmin, isRespondent, isTranslator } from 'constants/UserRoles';
import { NO_COMPANY_STATUSES } from 'constants/Experience';
import { validateTranslation } from 'components/Welcome/validation';

export function validateAboutMe({ values, userRole }) {
    const errors = {};

    if (!values.firstName) {
        errors.firstName = 'profile:error.firstName';
    }

    if (!values.lastName) {
        errors.lastName = 'profile:error.lastName';
    }

    if (!values.birthday) {
        errors.birthday = 'profile:error.birthday';
    }

    if (isCompanyAdmin(userRole)) {
        if (!values.workIndustry) {
            errors.workIndustry = 'profile:error.workIndustry';
        }

        if (!values.phone) {
            errors.phone = 'profile:error.phone';
        }
    } else {
        if (!values.gender) {
            errors.gender = 'profile:error.gender';
        }
    }

    return errors;
}

export function validateAddress({ values, userRole }) {
    const errors = {};
    if (userRole === 'TeamMember') {
        return {};
    }

    if (!values.city) {
        errors.city = 'profile:error.city';
    }

    if (!values.state) {
        errors.state = 'profile:error.state';
    }

    if (!values.house) {
        errors.house = 'profile:error.house';
    }

    if (!values.street) {
        errors.street = 'profile:error.street';
    }

    if (!values.postalCode) {
        errors.postalCode = 'profile:error.postalCode';
    }

    if (!values.country) {
        errors.country = 'profile:error.country';
    }

    return errors;
}

export function validateHourlyRate({ values, userRole }) {
    const errors = {};
    const { costPerHour, currency } = values;
    if (isCompanyAdmin(userRole)) {
        return {};
    }
    if (isRespondent(userRole) && !costPerHour) {
        // errors.costPerHour = 'profile:error.hourlyRate';
    }

    if (!currency) {
        errors.currency = 'profile:error.currency';
    }

    return errors;
}

export function validateLanguages({ values, userRole }) {
    const errors = {};
    const { languages } = values;
    if (isTranslator(userRole) || isCompanyAdmin(userRole)) return errors;

    if (!languages || !languages.length) {
        errors.languages = 'profile:error.languages';
    }

    return errors;
}

export function validateExperience({ values, userRole }) {
    const errors = {};

    if (isCompanyAdmin(userRole)) {
        return errors;
    }

    if (!values.company && !NO_COMPANY_STATUSES.includes(values.employmentStatus)) {
        errors.company = 'profile:error.company';
    }

    if (!values.occupation && !NO_COMPANY_STATUSES.includes(values.employmentStatus)) {
        errors.occupation = 'profile:error.occupation';
    }

    if (!values.employmentStatus) {
        errors.employmentStatus = 'profile:error.employmentStatus';
    }

    if (!values.workExperience && !NO_COMPANY_STATUSES.includes(values.employmentStatus)) {
        errors.workExperience = 'profile:error.workExperience';
    }

    return errors;
}

export function validateLanguageSkills({ values, userRole }) {
    let errors = {};

    if (!isTranslator(userRole)) {
        return errors;
    }

    errors = validateTranslation({ translateLanguages: values.translateLanguages }, '');

    return errors;
}
